import { render, staticRenderFns } from "./ArticleContent.vue?vue&type=template&id=0244d582"
import script from "./ArticleContent.vue?vue&type=script&lang=js"
export * from "./ArticleContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports